/**
 * Alias Uuid to string to clarify developer intent
 *
 * This should follow the UUID specification found at
 * [ietf.org](https://www.ietf.org/rfc/rfc4122.txt)
 */
export type Uuid = string;
